import { zonedTimeToUtc } from 'date-fns-tz';
import type { TimelineDuration, ColumnDuration } from '../model/timeline';

export const getDatePercentage = (targetDate: Date, from: Date, to: Date) => {
	// convert to UTC to measure dates because UTC doesn't have to deal with
	// daylight savings times. Our timeline renders all hours, including
	// dead hours at daylight savings time.
	const targetDateUTC = zonedTimeToUtc(new Date(targetDate), 'utc').valueOf();
	const fromUTC = zonedTimeToUtc(new Date(from), 'utc').valueOf();
	const toUTC = zonedTimeToUtc(new Date(to), 'utc').valueOf();
	const total = toUTC - fromUTC;
	return (targetDateUTC - fromUTC) / total;
};

export const getPositionForTimestamp = (
	timestamp: Date,
	timelineDuration: TimelineDuration,
): number => getDatePercentage(timestamp, timelineDuration.startDate, timelineDuration.endDate);

export const getTotalMilliseconds = ({ startDate, endDate }: TimelineDuration | ColumnDuration) =>
	zonedTimeToUtc(endDate, 'utc').valueOf() - zonedTimeToUtc(startDate, 'utc').valueOf();
